import React from "react";
import "./modal.css";
import Localize from "../../components/Localize/Localize";

const InfoModal = () => {
    const title = "POPUP_ERROR_TITLE";
    const description = "ADBLOCK_DETECTED";
    const accept = "POP_UNDERSTOOD";

    const handleConfirm = () => {
        window.location.reload();
    };
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-icon">⚠️</div>
                <h2>{Localize.translateToUpper(title)}</h2>
                <p>{Localize.translate(description)}</p>
                <div className="modal-buttons">
                    <button className="primary" onClick={handleConfirm}>
                        {Localize.translateToUpper(accept)}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InfoModal;
